var map = {
	"./access-denied.svg": "./src/assets/icons/access-denied.svg?2f6e",
	"./box.svg": "./src/assets/icons/box.svg?b804",
	"./captchaIcon.svg": "./src/assets/icons/captchaIcon.svg?e16e",
	"./checkIcon.svg": "./src/assets/icons/checkIcon.svg?6241",
	"./ic_alert_light.svg": "./src/assets/icons/ic_alert_light.svg",
	"./ic_arrow_right.svg": "./src/assets/icons/ic_arrow_right.svg?a908",
	"./ic_back.svg": "./src/assets/icons/ic_back.svg",
	"./ic_bill_pay.svg": "./src/assets/icons/ic_bill_pay.svg",
	"./ic_car.svg": "./src/assets/icons/ic_car.svg",
	"./ic_card.svg": "./src/assets/icons/ic_card.svg",
	"./ic_check_light.svg": "./src/assets/icons/ic_check_light.svg",
	"./ic_coint_light.svg": "./src/assets/icons/ic_coint_light.svg",
	"./ic_dashboard.svg": "./src/assets/icons/ic_dashboard.svg",
	"./ic_deposit_check.svg": "./src/assets/icons/ic_deposit_check.svg",
	"./ic_done_light.svg": "./src/assets/icons/ic_done_light.svg",
	"./ic_edit.svg": "./src/assets/icons/ic_edit.svg",
	"./ic_eye_close.svg": "./src/assets/icons/ic_eye_close.svg?7284",
	"./ic_eye_open.svg": "./src/assets/icons/ic_eye_open.svg?1f39",
	"./ic_guard.svg": "./src/assets/icons/ic_guard.svg",
	"./ic_investment_light.svg": "./src/assets/icons/ic_investment_light.svg",
	"./ic_logout.svg": "./src/assets/icons/ic_logout.svg",
	"./ic_mail.svg": "./src/assets/icons/ic_mail.svg",
	"./ic_menu.svg": "./src/assets/icons/ic_menu.svg",
	"./ic_plane.svg": "./src/assets/icons/ic_plane.svg",
	"./ic_plus.svg": "./src/assets/icons/ic_plus.svg",
	"./ic_search.svg": "./src/assets/icons/ic_search.svg",
	"./ic_settings.svg": "./src/assets/icons/ic_settings.svg",
	"./ic_signals.svg": "./src/assets/icons/ic_signals.svg?f25a",
	"./ic_transfer.svg": "./src/assets/icons/ic_transfer.svg",
	"./ic_user.svg": "./src/assets/icons/ic_user.svg",
	"./ic_vehicle.svg": "./src/assets/icons/ic_vehicle.svg",
	"./ic_zelle.svg": "./src/assets/icons/ic_zelle.svg",
	"./lockIcon.svg": "./src/assets/icons/lockIcon.svg?8bb5",
	"./pay_wallet.svg": "./src/assets/icons/pay_wallet.svg",
	"./scoreIcon_0.svg": "./src/assets/icons/scoreIcon_0.svg",
	"./scoreIcon_250.svg": "./src/assets/icons/scoreIcon_250.svg",
	"./scoreIcon_350.svg": "./src/assets/icons/scoreIcon_350.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";